import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import SlickSlider from 'react-slick';
import {uid} from 'react-uid';
import {Box} from '@tenancy.nz/design-system';
import Icon from './Icon';
import StyledPageHero, {
  StyledSliderContainer,
  StyledSlide,
  StyledSlideImage,
  StyledThumbSlider,
  StyledSliderThumb,
  StyledSliderArrow,
} from './PageHero.styled';

function PageHero({fixed = false, slides = [], title = undefined}) {
  const [slider, setSlider] = useState(null);
  const [thumbSlider, setThumbSlider] = useState(null);
  let sliderRef = useRef(null);
  let thumbSliderRef = useRef(null);

  useEffect(() => {
    setSlider(sliderRef);
    setThumbSlider(thumbSliderRef);
  }, []);

  const arrowProps = size => ({
    nextArrow: (
      <StyledSliderArrow>
        <Icon name="arrow-right" size={size} />
      </StyledSliderArrow>
    ),
    prevArrow: (
      <StyledSliderArrow direction="left">
        <Icon name="arrow-right" size={size} />
      </StyledSliderArrow>
    ),
  });

  const [main] = slides;
  if (!main) {
    return null;
  }
  return (
    <Box bgcolor="grey.50">
      <StyledPageHero fixed={fixed}>
        <StyledSliderContainer>
          {slides.length > 1 && (
            <SlickSlider
              arrows={false}
              dots={false}
              slidesToScroll={1}
              asNavFor={thumbSlider}
              ref={s => {
                // eslint-disable-next-line fp/no-mutation
                sliderRef = s;
              }}>
              {slides.map(slide => (
                <StyledSlide key={uid(slide)}>
                  <StyledSlideImage src={slide.src} />
                </StyledSlide>
              ))}
            </SlickSlider>
          )}
          {slides.length === 1 && <StyledSlideImage src={main.src} />}
        </StyledSliderContainer>
        {slides.length > 1 && (
          <StyledThumbSlider>
            <SlickSlider
              {...arrowProps('15px')}
              asNavFor={slider}
              dots={false}
              draggable={false}
              focusOnSelect
              slidesToShow={7}
              ref={s => {
                // eslint-disable-next-line fp/no-mutation
                thumbSliderRef = s;
              }}
              responsive={[
                {
                  breakpoint: 1280,
                  settings: {
                    slidesToShow: 6,
                  },
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 5,
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 5,
                  },
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 5,
                  },
                },
              ]}>
              {slides.map(slide => (
                <div key={`thumb-${uid(slide)}`}>
                  <StyledSliderThumb>
                    <StyledSlideImage src={slide.thumbSrc} />
                  </StyledSliderThumb>
                </div>
              ))}
            </SlickSlider>
          </StyledThumbSlider>
        )}
      </StyledPageHero>
    </Box>
  );
}

PageHero.propTypes = {
  /**
   *
   */
  fixed: PropTypes.bool,

  /**
   *
   */
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      thumbSrc: PropTypes.string.isRequired,
    })
  ),

  /**
   *
   */
  title: PropTypes.string,
};

export default PageHero;
